import { fetchApiData, fetchApiDataV2 } from "../../utils/utils"

export const getChannels=async (appInfo,careers)=>{
    const api=`category/list?type=home`
    return await fetchApiDataV2(appInfo,api)
}